import { selectSelectedBuildingNonCollectibleProduct } from "../../../selectors/selectRecipeInfo";
import { selectWaterTowerResourceInfo } from "../../../selectors/selectWatertowerInfo";
export var checkCollectibleWaterAmountExceedsStorage = function (path) { return function (action, state$, deps) {
    var state = state$.value;
    var waterCollected = selectWaterTowerResourceInfo(state);
    if (waterCollected != undefined) {
        var product = {
            amount: waterCollected.amount.toNumber(),
            resourceId: waterCollected.id,
        };
        var nonCollectibleProduct = selectSelectedBuildingNonCollectibleProduct(state, [product]);
        if (nonCollectibleProduct != undefined) {
            return path;
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/checks/checkCollectibleWaterAmountExceedsStorage.ts
// module id = 2506
// module chunks = 3